export const fsApiConfigCol = 'api-config';
export const fsUsersCol = 'users';
export const fsRolesCol = 'rbac-roles';
export const fsRbacLogsCol = 'rbac-logs';

export default fsApiConfigCol;
